$(document).ready(function() {

  let lastScrollTop = 0;
  const width = $(window).width();
  const mainnav = $(".header_main_navigation");
  const mobile_header = $(".mobile-header");
  const mobile_display = $(".mobile_search_display");
  const mobile_search_close = $(".mobile_search_image_close");
  const mobile_search_img = $(".mobile_search_image_open");
  const page_overlay = $(".page_overlay");
  const ipad_menu_toggle = $(".ipad-menu-toggle");
  const ipadparent_close = $(".ipad-parent-close");
  const headers = $(".header-01, .header-02, .header-03");
  const header_badge = $("header .badge");
  const header_4 = $('.header-04');
  const header_5 = $('.header-05');
  const header_7 = $('.header-07');
  const header_8 = $('.header-08');
  const header_Cart = $("header .cart");
  const cart_dropdown = $(".cart .dropdown");

  if(width<767) {
    $(window).scroll(function(event) {
      const st = $(this).scrollTop();
      if (st > 2 && st > lastScrollTop) {
        mainnav.css("display","none");
      } else {
        mainnav.css("display","flex");
      }
      lastScrollTop = st;
    });
  }

  $('.product-sec-count button.btn.dropdown-toggle').click(function() {
    if($('.product-sec-count').hasClass('sticky_selector')) {
      page_overlay.toggleClass('add');
    }
  });
  
  page_overlay.click(function(){
    page_overlay.removeClass('add');
  });
  
  if(width <= 1200) {
    $(window).on('scroll', function() {
      const scroll = $(this).scrollTop();
      const sticky_selector = 0;
      const product_sec_count = $('.container-wrap-collection .product-sec-count');
      if (scroll > sticky_selector) {
        product_sec_count.addClass('sticky_selector');
      } else {
        product_sec_count.removeClass('sticky_selector');
      }

      if (scroll <= sticky_selector) {
        product_sec_count.removeClass('sticky_selector');
      }
    });
  }

  $(window).on('scroll', function() {
    const scroll = $(window).scrollTop();
    const megamenu_dropdown = $('.megamenu .dropdown-menu');
    const megamenu_wrap = $('.megamenu-wrapper');
    const omega_src = $('.os-e.omega__autocomplete');
    if (scroll > 30) {
      megamenu_dropdown.addClass('dropdown_scroll');
      megamenu_wrap.css("top","106px");
      omega_src.addClass('searh_down');
    } else {
      megamenu_dropdown.removeClass('dropdown_scroll');
      megamenu_wrap.css("top","auto");
      omega_src.removeClass('searh_down');
    } 
  });
  
  if(width>767) {
    $(window).on('scroll', function() {
      const scroll = $(window).scrollTop();
      const secheader = $('#shopify-section-header header');
      if (scroll > 30) {
        secheader.css({"position":"fixed","top":"0"});
      } else {
        secheader.css({"position":"relative","top":"auto"});
      }
    });
  }
  
  if(width>767 && width<1024) {
    const sec_header = $('#shopify-section-header  header');
    $('.slide-column-open').click(function() {
      sec_header.css({"position":"relative","top":"auto","z-index":"2"});
    });
    $('.slide-column-close a').click(function() {
      sec_header.css({"position":"fixed","top":"0","z-index":"20"});
    });
  }

  const tabcontent_1 = $('.megamenu-wrapper .nav-tab-content .tab_content_1');
  const tabcontent_2 = $('.megamenu-wrapper .nav-tab-content .tab_content_2');
  const tabcontent_3 = $('.megamenu-wrapper .nav-tab-content .tab_content_3');
  const tabcontent_4 = $('.megamenu-wrapper .nav-tab-content .tab_content_4');
  const tabcontent_5 = $('.megamenu-wrapper .nav-tab-content .tab_content_5');

  $('.nav-tab-header .tabheader_1').on('mouseover focusin',function() {
    tabcontent_1.css('display','block');
    tabcontent_2.css('display','none');
    tabcontent_3.css('display','none');
    tabcontent_4.css('display','none');
    tabcontent_5.css('display','none');
  });

  $('.nav-tab-header .tabheader_1').on('mouseleave focusout',function() {
    tabcontent_1.css('display','block');
  });

  $('.nav-tab-header .tabheader_2').on('mouseover focusin',function() {
    tabcontent_2.css('display','block');
    tabcontent_1.css('display','none');
    tabcontent_3.css('display','none');
    tabcontent_4.css('display','none');
    tabcontent_5.css('display','none');
  });

  $('.nav-tab-header .tabheader_2').on('mouseleave focusout',function() {
    tabcontent_2.css('display','none');
  });

  $('.nav-tab-header .tabheader_3').on('mouseover focusin',function() {
    tabcontent_3.css('display','block');
    tabcontent_2.css('display','none');
    tabcontent_1.css('display','none');
    tabcontent_4.css('display','none');
    tabcontent_5.css('display','none');
  });

  $('.nav-tab-header .tabheader_3').on('mouseleave focusout',function() {
    tabcontent_3.css('display','none');
  });

  $('.nav-tab-header .tabheader_4').on('mouseover focusin',function() {
    tabcontent_4.css('display','block');
    tabcontent_2.css('display','none');
    tabcontent_3.css('display','none');
    tabcontent_1.css('display','none');
    tabcontent_5.css('display','none');
  });

  $('.nav-tab-header .tabheader_4').on('mouseleave focusout',function() {
    tabcontent_4.css('display','none');
  });

  $('.nav-tab-header .tabheader_5').on('mouseover focusin',function() {
    tabcontent_5.css('display','block');
    tabcontent_2.css('display','none');
    tabcontent_3.css('display','none');
    tabcontent_4.css('display','none');
    tabcontent_1.css('display','none');
  });
  
  $('.nav-tab-header .tabheader_5').on('mouseleave focusout',function() {
    tabcontent_5.css('display','none');
  });
  
  const tabheader_1 = $(".tabheader_1");
  const tabheader_2 = $(".tabheader_2");
  const tabheader_3 = $(".tabheader_3");
  const tabheader_4 = $(".tabheader_4");

  tabheader_2.on('mouseover focusin',function() {
    tabheader_1.removeClass('active');
  });

  tabheader_3.on('mouseover focusin',function() {
    tabheader_1.removeClass('active');
  });

  tabheader_4.on('mouseover focusin',function() {
    tabheader_1.removeClass('active');
  });

  tabheader_4.on('mouseover focusin',function() {
    tabheader_1.removeClass('active');
  });
  
  mobile_search_img.click(function() {
    mobile_header.addClass('mobile_sticky');
  });
  
  mobile_search_close.click(function() {
    mobile_header.removeClass('mobile_sticky');
  });

  $('#search_field_box').on("input", function() {
    mobile_display.addClass('searching_product');
  });
  
  $('.search-dropdown .search-close').click(function() {
    mobile_display.removeClass('searching_product');
  });

  if(width > 1200) {
    $(".desktop-header .header_main_navigation .header-menu").hover(function(){
      $('.desktop_shadow_effect').toggleClass('sub_shadow')
    });
  }
  
  ipad_menu_toggle.on('click touch',function() {
    mobile_header.addClass('mobile_sticky');
    if(width <= 1200){
      $('.ipad_transparent').addClass('add');
    }
    if(width <= 767){
      mainnav.addClass('mobile_shadow');
    }
  });

  ipadparent_close.on('click touch',function() {
    mobile_header.removeClass('mobile_sticky');
    if(width <= 1200){

      $('.ipad_transparent').removeClass('add');
    }
    if(width <= 767){
      mainnav.removeClass('mobile_shadow');
    }
  });

  const megamenu_li = $('.header-menu li.megamenu');
  const megamenu_header = $('header');
  megamenu_li.mouseenter(function() {
    megamenu_header.css("z-index","15");
  });
  
  megamenu_li.mouseleave(function() {
    megamenu_header.css("z-index","8");
  });

  const announcement = $('#announcement');
  const header_topmenu = $('.header_top_menu');
  $('.header_main_search .cart a ').click(function() {
    announcement.css("z-index","1");
    header_topmenu.css("z-index","1");
  });

  $('.dropdown-menu-cart-wrapper .cart-close').click(function() {
    announcement.css("z-index","9");
    header_topmenu.css("z-index","8");
  });

  mobile_search_img.click(function() {
    announcement.css("z-index","1");
  });
  
  mobile_search_close.click(function() {
    announcement.css("z-index","9");
  });

  if(width <= 1024) {
    ipad_menu_toggle.click(function(){
      announcement.css("z-index","1");
    });
    
    ipadparent_close.click(function(){
      announcement.css("z-index","9");
    });
  }
  
  $(".login-form-box .errors ul li").css({"color": "#767676", "font-weight": "bold"});

  $('.main-parent-cart .cart .dropdown-toggle').on('click',function() {
    $('body').addClass('cart-open');
  });
  
  $('.main-parent-cart .cart .cart-close').on('click',function() {
    $('body').removeClass('cart-open');
  });
  
  const register_input = $('.login_form_box_wrapper .login_form_box .field input');
  register_input.each(function() {
    $(this).on('focusin',function() {
      $(this).parents('.field').addClass('active');
    });
    
    $(this).on('focusout',function() {
      $(this).parents('.field').removeClass('active');
    });
  });
  
  const login_form = $('.login_form_box .lg_wr');
  const login_form_wr = $('.login_form_box .re_wr');
  $('.login_form_box .lg_wr .bottom_customer .rec_wrp a').on('click',function() {
    login_form.addClass('hide');
    login_form_wr.addClass('show');
  });
  
  $('.login_form_box .re_wr .bottom_reset .reset_wrp a').on('click',function() {
    login_form.removeClass('hide');
    login_form_wr.removeClass('show');
  });
  
  const create_input = $('.form_box_wrapper .register_form_box .field input');
  create_input.each(function() {
    $(this).on('focusin',function(){
      $(this).parents('.field').addClass('active');
    });
    
    $(this).on('focusout',function(){
      $(this).parents('.field').removeClass('active');
    });
  });
  
  const reset_input = $('.reset_password_inner .reset_form_box .field input');
  reset_input.each(function() {
    $(this).on('focusin',function(){
      $(this).parents('.field').addClass('active');
    });

    $(this).on('focusout',function() {
      $(this).parents('.field').removeClass('active');
    });
  });
  
  if($(this).hasClass('active')) {
    $(this).attr("aria-expanded","true")
  }
  
  const product_title = $('.tt-product-page__tabs .tt-tabs__title');
  product_title.each(function() {
    $(this).on('click',function() {
      if($(this).hasClass('active')) {
        $(this).attr("aria-expanded","true")
      } else {
        $(this).attr("aria-expanded","false")
      }
    });
  });
  
  const product_title_tab = $('.item__faq a');
  product_title_tab.each(function() {
    $(this).on('click',function() {
      if($(this).hasClass('open')) {
        $(this).attr("aria-expanded","false")
      } else {
        $(this).attr("aria-expanded","true")
      }
    });
  });
  
  const communityvideo = $('#community-video');
  const communitylistingvideo = $('#community-listing-video');
  $('.our-community-stories .play-btn').on('click',function() {
    if(! $('body').hasClass('model_open')) {
      communityvideo.addClass("show");
      communitylistingvideo.addClass("show");
      communityvideo.css("display","block");
      communitylistingvideo.css("display","block");
      $('body').addClass('model_open');
    } else {
      communityvideo.removeClass("show");
      communitylistingvideo.removeClass("show");
      communityvideo.css("display","none");
      communitylistingvideo.css("display","none");
      $('body').removeClass('model_open');
    }
  });
  
  communityvideo.on('click',function() {
    if($('body').hasClass('model_open')) {
      communityvideo.css("display","none");
      $('body').removeClass('model_open');
      communityvideo.removeClass("show");
    }
  });
  
  communitylistingvideo.on('click',function() {
    if($('body').hasClass('model_open')) {
      communitylistingvideo.css("display","none");
      $('body').removeClass('model_open');
      communitylistingvideo.removeClass("show");
    }
  });

  $("#recover-password .errors ul li").html("If the entered email address is in our records you will receive an email with the steps to reset your password.");

  $("#create_customer").on('submit', function(event) {
    const fname = $("#create_customer #LoginFormName1").val();
    const lname = $("#create_customer #LoginFormName2").val();
    const mail = $("#create_customer #LoginEmail").val();
    const pass = $("#create_customer #LoginFormPass1").val();
    
    const fnameerror = $("#create_customer .error_fname");
    const lnameerror = $("#create_customer .error_lname");
    const emailerror = $("#create_customer .error_email");
    const passerror  = $("#create_customer .error_pass");
    
    if((mail.length !== 0) && (pass.length !== 0) && (fname.length !== 0) && (lname.length !== 0)) {
      return true;
    }
    
    if(fname.length === 0) {
      fnameerror.html("Please enter your first name");
      return false;
    } else {
      fnameerror.html("");
    }
    
    if(lname.length === 0) {
      lnameerror.html("Please enter your last name");
      return false;
    } else {
      lnameerror.html("");
    }
    
    if(mail.length === 0) {
      emailerror.html("Please enter your email");
      return false;
    } else {
      emailerror.html("");
    }
    
    if(pass.length === 0) {
      passerror.html("Please enter your password");
      return false;
    } else {
      passerror.html("");
    }    
  });
  
  $("#reset_customer_password").on('submit', function(event) {
    const passwordTxt  = $("#reset_customer_password #LoginFormPass1").val();
    const password2Txt = $("#reset_customer_password #LoginFormPass2").val();
    const passwordErr = $("#reset_customer_password .error_repass");
    
    if((passwordTxt.match(/[a-z]/g) && passwordTxt.match(/[A-Z]/g) && passwordTxt.match(/[0-9]/g) && passwordTxt.match(/[^a-zA-Z\d]/g) && passwordTxt.length >= 8) &&
       (password2Txt.match(/[a-z]/g) && password2Txt.match(/[A-Z]/g) && password2Txt.match(/[0-9]/g) && password2Txt.match(/[^a-zA-Z\d]/g) && password2Txt.length >= 8)) {
      passwordErr.html("");
      return true;
    } else {
      event.preventDefault();
      passwordErr.html("Password must contain uppercase, lowercase, number, special character and minimum 8 characters.");
      return false;
    }
  });
  
  $(".step-2 .banner_bottom_heading,.step-2 p,.step-2 .form-group label").attr("tabindex","0");
  $(".step-3 .banner_bottom_heading,.step-3 p,.step-3 .form-group label").attr("tabindex","0");
  
  const slick_slide = $(".slick-slide");
  slick_slide.attr("aria-hidden","false");

  const slickval = $(".slick-slide img").attr("alt");
  slick_slide.attr("aria-label",slickval);
  
  $(".slick-slide a").attr("tabindex","-1");
  slick_slide.keypress(function() {
    $("img",this).trigger("click");
  });
  
  $(".confirm_age").keypress(function() {
    const agree = $("#agree");
    if(agree.prop("checked") === false) {
      agree.prop("checked", true);
    } else {
      agree.prop("checked", false);
    }
  });
  
  $(".form-group").keypress(function() {
    if($("input",this).prop("checked") === false) {
      $("input",this).prop( "checked", true );
    } else {
      $("input",this).prop( "checked", false );
    }
    
    const purchased_brands = $("#purchased-brands_none_last_step2");
    const brands_input = $(".brands input");
    if(purchased_brands === true) {
      brands_input.prop("checked", false);
      purchased_brands.prop("checked", true);
    }
    
    const symptoms_none = $("#symptoms_none");
    const symptoms_input = $(".symptoms input");
    if(symptoms_none.prop("checked") === true) {
      symptoms_input.prop( "checked", false );
      symptoms_none.prop( "checked", true);
    }
  });
  
  $(".phone_text .form-phone").keypress(function() {
    $(".phone_text .form-phone input").focus();
  });
  
  $(".phone_text .form-phone input").on('keydown', function(e) {
    if (e.keyCode === 9) {
      $(".step-3-check-agree").focus();
    }
  });
  
  $(".cart").keypress(function(event) {
    if(event.keyCode === 13) {
      $('.cart .dropdown-toggle .link-image').trigger("click");
    }
  });
  
  $(".breadcrumb_withouturl").attr("tabindex","0");
  document.body.addEventListener('keydown', function(e) {
    if(e.keyCode === 13) {
      if(document.activeElement.className === 'ipad_coupon') {
        window.location.href = '/pages/savings'
      }

      if(document.activeElement.className === 'dropdown-toggle') {
        setTimeout(function() {
           cart_dropdown.toggleClass('open');
        }, 0);
        $('.icon.icon-close.cart-close').focus();
      }

      if(document.activeElement.className === 'mobile_sticky_search') {
        mobile_search_img.hide();
        mobile_search_close.show();
        mobile_display.show();
        mobile_header.addClass('mobile_sticky');
        header_badge.addClass('badge--hidden');
        headers.length > 0 && $('.header-menu').addClass('opacity');
        (header_4.length > 0 || header_8.length > 0) && $('.logo, .toggle-menu, .language, .currency, .account, .cart').addClass('opacity');
        header_5.length > 0 && $('.logo, .account, .cart, .header-menu').addClass('opacity');
        header_7.length > 0 && $('.cart').addClass('opacity');
      }

      if(document.activeElement.className === 'ipad_locator') {
        window.location.href = '/pages/where-to-buy';
      }

      if(document.activeElement.className === 'mobile_sticky_search active') {
        mobile_search_img.show();
        mobile_search_close.hide();
        mobile_display.hide();
        mobile_header.removeClass('mobile_sticky');
      }
    }
  
    if(e.keyCode === 9 ) {
      if(e.shiftKey) {
        return true;
      } else {
        if(document.activeElement.className === 'last-element') {
          ipadparent_close.click();
          ipad_menu_toggle.focus();
        }
      }
    }
  });

  "use strict";
  headerViewSearch(); 
  cartSlideIni();
  
  // header view search
  function headerViewSearch() {
    $('body').on('click', 'header .search-open', function(e) {
      e.preventDefault();
      $(this).parent('.search').addClass('open');
      $(this).next('#search-dropdown, .search-dropdown').addClass('open');
      header_badge.addClass('badge--hidden');
      headers.length > 0 && $('.header-menu').addClass('opacity');
      (header_4.length > 0 || header_8.length > 0) && $('.logo, .toggle-menu, .language, .currency, .account, .cart').addClass('opacity');
      header_5.length > 0 && $('.logo, .account, .cart, .header-menu').addClass('opacity');
      header_7.length > 0 && $('.cart').addClass('opacity');
    })
    .on('click', 'header .search-close', function(e) {
      e.preventDefault();
      $(this).closest('.search').removeClass('open');
      $(this).closest('#search-dropdown, .search-dropdown').removeClass('open');
      header_badge.removeClass('badge--hidden');

      headers.length > 0 && $('.header-menu').removeClass('opacity');
      (header_4.length > 0 || header_8.length > 0) && $('.logo, .toggle-menu, .language, .currency, .account, .cart').removeClass('opacity');
      header_5.length > 0 && $('.logo, .account, .cart, .header-menu').removeClass('opacity');
      header_7.length > 0 && $('.cart').removeClass('opacity');
    });
  }
  
  // header Mini Cart
  function cartSlideIni() {
    if (header_Cart.length > 0) {
      $('body').on('click', 'header .cart .dropdown-toggle',function(e) {
        headerCartSize();
        setTimeout(function(){ cart_dropdown.toggleClass('open'); }, 0);
        e.preventDefault();
      })
      .on('click', 'header .cart .cart-close', function(e) {
        cart_dropdown.toggleClass('open');
        $('body').removeClass('cart-open');
        e.preventDefault();
      });
      $(window).resize(function() {
        cart_dropdown.hasClass('open') && headerCartSize();
      });
    }
  }  
  
  function headerCartSize() {
    header_Cart.find(".dropdown-menu").scrollTop(0);
    cartHeight();
  }

  function cartHeight() {
    const $obj = header_Cart.find(".dropdown-menu");
    $obj.removeAttr('style');
    setTimeout(function() {
      const w_height = $(window).height();
      const o_height = $obj.height();
      const delta = parseInt((w_height - o_height), 10);

      if (delta < 0) {
        $obj.css({
          "max-height": o_height + delta,
          "overflow": "auto",
          "overflow-x": "hidden"
        });
      } else {
        return true;
      }
    }, 10);
  }
  
  /* Back to Top */
  const annoncement_text = "<div class='modal-filter'></div>";
  $("#back_to_top").click(function() {
    if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
      window.scrollTo(0,0)
    } else {
      $("body").animate({ scrollTop: 0 }, "slow");
    }
  });
  
  $(".announcement-close").click(function() {
    $("#shopify-section-announcement").hide();
  });
  
  $(".main-nav li").mouseenter(function() {
    $(this).toggleClass("active");
  });
  
  const slide_close = $('.slide-column-close');
  const btn_filter = $('.extra-btn-filter');
  
  btn_filter.click(function() {
    const aside_left = $('.aside.leftColumn');
    const model_filter = $(".modal-filter");
    aside_left.addClass('column-open');
    slide_close.addClass('column-open');
    slide_close.addClass('position-fix');
    $('body').append(annoncement_text);
  });
  
  slide_close.click(function() {
    const aside_left = $('.aside.leftColumn');
    const model_filter = $(".modal-filter");
    aside_left.removeClass('column-open');
    slide_close.removeClass('column-open');
    slide_close.removeClass('position-fix');
    model_filter.remove();
  });

  /* ADA Features */
  setTimeout(function() {
    const product_title = $('.tt-product-page__tabs .tt-tabs__title');
    product_title.each(function(){
      if($(this).hasClass('active')){
        $(this).attr("aria-expanded","true")
      }
    });
  },1000);  
  
  const URL = $(location).attr('href');
  const GET_ARR = URL.split('#');  
  if(GET_ARR[1] === 'recover') {
    $('.login_form_box .lg_wr').addClass('hide');
    $('.login_form_box .re_wr').addClass('show');
  }

  /* PCP PAGE - WHEN CHOOSING VARIANT CHANGE THE PRODUCT IAMGE */
  $('body').on('change', '.productitem-option1-js ', function(e) {
    const $this = $(this);
    const _parent = $this.parent();
    _parent.parent().find(".active").removeClass('active');
    _parent.addClass('active');
    const pr_parent = $this.closest('.product');
    pr_parent.find('input').val(_parent.attr('data-var_id'));
    const img_src = $this.children("option:selected")[0].attributes['data-img'].value;

    if(img_src !== "") {
      $this.parent().parents('.product_inside').find('.image-box').find('img').first().attr('src', img_src);
    }
  });
});

const pathname = window.location.pathname;
if( pathname !== "/pages/savings") {
  (function() {
      const app = function($) {
      const _this = this;
      let _currentId;
      const _collapsibles = $('[data-behavior="collapsible"]');

      for( let collapsible in _collapsibles) {
        $(collapsible).on( 'click' , function(e){
        const id = $(e.target).data("id");
        if( id !== _currentId && $(e.target).data("id") ) {
          e.preventDefault();
          if( _currentId ) {
            closeCurrentOpen( _currentId );
          }
          $(e.target).addClass('open');
          $(`[data-target="${id}"]`).slideDown().addClass('open');
          _currentId = id;
        }else if( $(e.target).hasClass("open") ){
          e.preventDefault();
          closeCurrentOpen( _currentId );
        }
        });
      }

      function closeCurrentOpen( id ) {
        _currentId = false;
        $(`[data-target="${id}"]`).slideUp().removeClass('open');
        $(`[data-id="${id}"]`).removeClass('open');
      }
    }

    function loadScript(url, callback) {
      const script = document.createElement("script");
      script.type = "text/javascript";

      if (script.readyState){  //IE
        script.onreadystatechange = function(){
          if (script.readyState === "loaded" ||
              script.readyState === "complete"){
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {  //Others
        script.onload = function(){
          callback();
        };
      }
      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
    }
    app(jQuery);
  })();
}